import { useMemo } from 'react';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { formatCentsToDollars } from 'marketplace-ui-common/utils/currency';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CurrencyText({
  cents
}) {
  const dollars = useMemo(() => formatCentsToDollars(cents), [cents]);
  if (dollars % 1) {
    return /*#__PURE__*/_jsx(FormattedIntlCurrency, {
      value: dollars,
      currencyCode: "USD"
    });
  }
  return /*#__PURE__*/_jsx(FormattedIntlCurrency, {
    value: dollars,
    trailingZeroDisplay: "stripIfInteger",
    currencyCode: "USD"
  });
}